export default __webpack_public_path__ + "assets/images/9a875fac03f691d6ed59d6cc52b1a32a.png";